import { createUseStyles } from 'react-jss'
import { textSize, color, backgroundColor, boldFont, getThemedColor } from 'styles/helpers'
import config from 'styles/config'

export default createUseStyles(theme => ({
  steps: {
    position: 'relative',
    marginBottom: 40,
    textAlign: 'center',
  },
  stepsSmall: {
    marginLeft: -40,
    marginRight: -40,

    '& $stepMobileName': {
      marginLeft: 40,
      marginRight: 40,
    }
  },
  stepNames: {
    position: 'relative',
    zIndex: 5,
  },
  stepName: {
    display: 'none'
  },
  stepNum: {
    display: 'inline-block',
    position: 'absolute',
    top: 0,
    width: 20,
    height: 20,
    marginLeft: -10,
    borderRadius: 18,
    ...textSize(14, 18),
    textAlign: 'center',
    ...color('disabled', theme.theme),
    border: `1px solid ${getThemedColor(theme.theme, 'disabled')}`,
    ...backgroundColor('mainBackground', theme.theme),
  },
  step: {
    display: 'inline-block',
    ...textSize(14, 18),
    ...color('textSecondary', theme.theme),
  },
  stepOn: {
    '& $stepNum': {
      backgroundColor: theme.main_color,
      borderColor: theme.main_color,
      ...color('mainBackground', theme.theme),
      ...boldFont(),
    },
  },
  stepSmall: {},
  stepTrack: {
    position: 'absolute',
    zIndex: 1,
    left: 0,
    right: 0,
    top: 0,
    lineHeight: '11px',
  },
  stepTrackSegment: {
    display: 'inline-block',
    height: 1,
    ...backgroundColor('disabled', theme.theme),
  },
  stepTrackSegmentOn: {
    backgroundColor: theme.main_color,
  },
  stepMobileName: {
    marginTop: 40,
    marginBottom: -35,
    textAlign: 'left',
  },

  [config.mediaQueries.tabletPortrait]: {
    stepName: {
      display: 'block',
    },
    stepNum: {
      display: 'none',
    },
    step: {
      position: 'relative',

      '&:after': {
        content: '""',
        display: 'block',
        margin: '6px auto -5px auto',
        width: 6,
        height: 6,
        ...backgroundColor('mainBackground', theme.theme),
        border: `2px solid ${getThemedColor(theme.theme, 'disabled')}`,
        borderRadius: 10
      },

      '&:before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        width: 10,
        height: 10,
        left: '50%',
        marginLeft: -11,
        bottom: -11,
        border: `6px solid ${getThemedColor(theme.theme, 'mainBackground')}`,
        borderRadius: 16
      }
    },
    stepOn: {
      color: theme.main_color,
      ...boldFont(),

      '&:after': {
        borderColor: theme.main_color,
      },
    },
    stepSmall: {
      ...textSize(12, 18),
    },
    stepTrack: {
      top: 'auto',
      bottom: -5,
      lineHeight: 'normal',
    },
    stepMobileName: {
      display: 'none',
    }
  }
}))
